import React from 'react';
import ContentsExplorer from '.';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';
import contentsExplorerUrl from './urls';

const routes = () => {
    const routesMap = [];
    // handling Grade & Module routes, territory can be extracted from store

    routesMap.push(
        <AuthenticatedLayoutRoute exact key="/contents-explorer" path={contentsExplorerUrl} title="Contents Explorer">
            <ContentsExplorer />
        </AuthenticatedLayoutRoute>,
        <AuthenticatedLayoutRoute
            exact
            key="/contents-explorer/grade"
            path={`${contentsExplorerUrl}/:gradeId`}
            title="Contents Explorer"
        >
            <ContentsExplorer />
        </AuthenticatedLayoutRoute>,
        <AuthenticatedLayoutRoute
            exact
            key="/contents-explorer/grade/module"
            path={`${contentsExplorerUrl}/:gradeId/:moduleId`}
            title="Contents Explorer"
        >
            <ContentsExplorer />
        </AuthenticatedLayoutRoute>,
    );

    return routesMap;
};

export default routes;
